export default function (state, data) {
    let v = data.PaymentData;
    debugger
    if (!v && !v.Id) return;
    state.Id = v.Id;
    state.PaymentOperationID = v.PaymentOperationID;
    state.CategoryId = v.Id;
    state.PaymentTypeId = v.PaymentTypeId;
    state.CashId = v.CashId;
    state.PaymentAccountId = v.Id;
    state.Sum = v.Sum;
    state.BankCommission = v.BankCommission;
    state.CurrencyId = v.CurrencyId;
    state.AccountNumber = v.AccountNumber;
    state.PaymentDate = v.PaymentDate.Serialized;
    state.DocumentNumber = v.DocumentNumber;
    state.Comment = v.Comment;
    state.PaymentDetails = v.PaymentDetails;
    state.loading = false;
    state.data = data;
}